export default function formSetDynamicErrors({
  e,
  form,
  trans = (key) => key,
}) {
  if (e?.response?.data?.errors) {
    form.setFields(Object.keys(e?.response?.data?.errors).map(((key) => ({
      name: key,
      // @ts-expect-error
      errors: [trans ? trans(e?.response?.data?.errors[key]) : e?.response?.data?.errors[key]],
    }))));
  }
}
